import api from "@/services/api";

import { PartnerType } from "@/types/partner/Partner";

class GetAllPartners {
  execute = async (franchiseId?: string, associateId?: string, status?: string) => {
    const params = new URLSearchParams();
    if (franchiseId) {
      params.set("franchise", franchiseId);
    }
    if (associateId) {
      params.set("associateId", associateId);
    }
    if (status) {
      params.set("status", status);
    }
    const partners = await api().get(`/partners?${params.toString()}`);
    return partners.data.partners as PartnerType[];
  };
}

export { GetAllPartners };
